import type { Saga } from 'redux-saga';
import { all, call, spawn } from 'redux-saga/effects';
import { watchFetchAbTestUserData } from '../abTest/abTest';
import { watchFetchAdminData } from '../admin/admin.ts';
import { watchFetchBaseData } from '../app/base';
import { watchFetchSaleData } from '../app/sale';
import { watchUpdateFavorites } from '../favorites/favorites';
import { watchFetchProducts } from '../fetchProducts/fetchProducts';
import watchFetchUserData from '../user/user';

export default function* rootSaga(): Saga<void> {
  const sagas = [
    watchFetchBaseData,
    watchFetchSaleData,
    watchFetchProducts,
    watchUpdateFavorites,
    watchFetchAdminData,
    watchFetchUserData,
    watchFetchAbTestUserData,
  ];

  /*
    We loop through sagas here so that we can call spawn (https://redux-saga.js.org/docs/api/) on each worker.
    Putting them in a while loop allows us to be able to restart the worker in the event of
    failure (https://redux-saga.js.org/docs/advanced/RootSaga.html#keeping-everything-alive).
  */
  yield all(
    sagas.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (error) {
            // TODO: clean up error messages
            console.log(error);
          }
        }
      }),
    ),
  );
}
